import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";
import { Grid, CircularProgress } from "@material-ui/core";
import CSSModules from "react-css-modules";
import HtmlParser from "react-html-parser";
import { number } from "../../../utils";

@CSSModules(styles, { allowMultiple: true })
class MeterTree extends Component {
	componentWillMount() {}

	getTitle(units) {
		let result = '<div style="font-family:Helvetica;color:#4D4D4D;font-size:20px;font-weight:600;margin-bottom:10px;">'; 
		switch(units) {
			case "$":
				result += 'Rolling Hour - Cost';
				break;
			case "kWh":
				result += 'Rolling Hour - kWh';
				break;
			case "kW":
				result += 'kW Demand';
				break;
			case "kgCO₂":
				result += 'Rolling Hour - kgCO₂';
				break;
			default:
				break;
		}
		result += '</div>';
		return result;
	}

	render() {
		if(!this.props.meterTree){
			return null;
		}	
		return (
			<div styleName="component-wrapper">
				{HtmlParser(this.getTitle(this.props.units))}
				{this.renderMeters(this.props.meterTree)}
			</div>
		);
	}

	renderMeters(columns){
		return (
			<React.Fragment>
			{columns.map((column, columnIndex) => 
				this.renderColumn(column, columnIndex)
			)}
			</React.Fragment>
		);
	}

	renderColumn(column, columnIndex){
		return (
			<div styleName="column-wrapper" key={columnIndex}>
				<div styleName="pipe-wrapper">
				{column.pipes.map((pipe, pipeIndex) => 
					this.renderPipe(pipe, pipeIndex)
				)}
				{column.pipes.length === 0 && 
					<div style={{width: "10px", display: "inline-block", height: "100%"}}></div>
				}
				</div>
				<div styleName="block-wrapper">
				{column.blocks.map((block, blockIndex) => 
					this.renderBlock(block, blockIndex)
				)}
				</div>
			</div>
		);
	}

	renderPipe(pipe, pipeIndex){
		let blockHeight = 120;
		let blockPadding = 16;
		let pipeHeight = pipe.types.length * (blockHeight + blockPadding);
		//take away the top half of teh first block and the bottom half of the last blocm (= 1 height + padding)
		pipeHeight -= (blockHeight + blockPadding);
		pipeHeight += 2;
		//pipe top offset
		let topOffset = pipe.startIndex * (blockHeight + blockPadding);
		//plus teh first half of the first block
		topOffset += ((blockHeight + blockPadding) / 2);
		topOffset -= 1;
		//pipe gradient
		let mainMeterColor = "rgb(15, 39, 72)";
		let standardMeterColor = "rgb(85, 108, 171)";
		let virtualMeterColor = "rgb(45, 155, 177)";
		let pipeColor = "linear-gradient(";
		for(var ii = 0; ii < pipe.types.length; ii++){
			if(ii > 0){
				pipeColor += ",";
			}
			switch(pipe.types[ii]){
				case "main":
					pipeColor += mainMeterColor;
					break;
				case "standard":
					pipeColor += standardMeterColor;
					break;
				case "virtual":
					pipeColor += virtualMeterColor;
					break;
				default:
					break;
			}
		}
		pipeColor += ")";

		let styles = {
			height: pipeHeight + "px",
			background: pipeColor,
			top: topOffset + "px"
		};
		return (
			<div styleName="pipe-container" key={pipeIndex}>
				<div styleName="pipe-content" style={styles}>
				</div>
			</div>
		);
	}

	getColorForType(type){
		let mainMeterColor = "rgb(15, 39, 72)";
		let standardMeterColor = "rgb(85, 108, 171)";
		let virtualMeterColor = "rgb(45, 155, 177)";
		switch(type){
			case "main":
					return mainMeterColor;
				case "standard":
					return standardMeterColor;
				case "virtual":
					return virtualMeterColor;
				default:
					return standardMeterColor;
		}
	}

	getIdForBlock(block, units) {
		switch(units) {
			case "$":
				return block.powerUsagePointId;
			case "kWh":
				return block.powerUsagePointId;
			case "kW":
				return block.powerRatePointId;
			case "kgCO₂":
				return block.powerUsagePointId;
			default:
				return "";
		}
	}

	renderBlock(block, blockIndex){
		let showRightConnector = block.children && block.children.length > 0;
		let showLeftConnector = !!block.parentViewId;


		let leftConnectorStyle = { };
		if(block.parentType === "main" && block.type !== "virtual"){
			leftConnectorStyle.background = "linear-gradient(to right, "
			+ this.getColorForType(block.parentType) + ","
			+ this.getColorForType(block.type) + ")";
		}else{
			leftConnectorStyle.backgroundColor = this.getColorForType(block.type);
		}
		let leftConnectorTopMaskStyle = {};
		let leftConnectorBottomMaskStyle = {};
		if(block.firstChild){
			leftConnectorTopMaskStyle.borderBottomLeftRadius = "0px";
			leftConnectorBottomMaskStyle.borderTopLeftRadius = "0px";
		}
		if(block.lastChild){
			leftConnectorBottomMaskStyle.borderTopLeftRadius = "0px";
		}

		let leftStickStyle = {};
		if(showLeftConnector){
			if(block.parentType === "main" && block.type !== "virtual"){
				leftStickStyle.width = "45px";
				leftStickStyle.left = "-45px";
				leftStickStyle.background = "linear-gradient(to right, " 
				+ this.getColorForType(block.parentType) + ","
				+ this.getColorForType(block.type) + ")";
			}else if(block.onlyChild){
				leftStickStyle.background = "linear-gradient(to right, " 
				+ this.getColorForType(block.parentType) + ", " 
				+ this.getColorForType(block.type) + ", " 
				+ this.getColorForType(block.type) + ")";
			}else{
				leftStickStyle.width = "45px";
				leftStickStyle.left = "-45px";
				leftStickStyle.backgroundColor = this.getColorForType(block.type);
			}
		}


		let rightConnectorStyle = {	};
		if(block.type === "main" && block.firstChildType !== "virtual"){
			rightConnectorStyle.backgroundColor = this.getColorForType(block.type);
		}else{
			rightConnectorStyle.background = "linear-gradient(to right, " + this.getColorForType(block.type) + ", " + this.getColorForType(block.firstChildType) + ")";
		}
		let rightConnectorTopMaskStyle = {
			borderBottomRightRadius: "0px"
		};
		let rightConnectorBottomMaskStyle = {};

		return (
			<div styleName="block-container" key={blockIndex}>
			{showLeftConnector &&
				<div styleName="block-connector-left" style={leftConnectorStyle}>
				<div styleName="block-connector-top-mask" style={leftConnectorTopMaskStyle}></div>
				<div styleName="block-connector-bottom-mask" style={leftConnectorBottomMaskStyle}></div>
			</div>}
			{showLeftConnector && 
				<div styleName="left-stick" style={leftStickStyle}></div>
			}

				<div styleName="block-content"  root={(block.type === "main").toString()} virtual={(block.type === "virtual").toString()} blank={(block.type === "blank").toString()} >
					<div styleName="meter-value">
						{!this.props.forceBusy && this.props.units === "$" && <span styleName="meter-units">{this.props.units}&nbsp;</span>}
						{!this.props.forceBusy && number.parseNumber(block.value, this.props.units === "$" ? 2 : 0)}
						{!this.props.forceBusy && this.props.units !== "$" && <span styleName="meter-units">&nbsp;{this.props.units}</span>}
						{this.props.forceBusy && <CircularProgress color="inherit" />}
					</div>
					<div styleName="meter-name">
						{!this.props.forceBusy && block.name}
					</div>
					{
						this.props.isdebug &&
						<div styleName="meter-name">
							{!this.props.forceBusy && this.getIdForBlock(block, this.props.units)}
						</div>
					}
				</div>

				{showRightConnector &&
					<div styleName="block-connector-right" style={rightConnectorStyle}>
					<div styleName="block-connector-top-mask" style={rightConnectorTopMaskStyle}></div>
					<div styleName="block-connector-bottom-mask" style={rightConnectorBottomMaskStyle}></div>
				</div>
				}
			</div>
		);
	}

	componentDidMount(){
		this.props.startLiveData();
	}

	componentWillUnmount(){
        this.props.stopLiveData();
    }
	
}

const bindAction = dispatch => {
	return {
		startLiveData: () => dispatch(actions.startLiveData()),
        stopLiveData: () => dispatch(actions.stopLiveData()),
	};
};

const mapStateToProps = state => ({
	meterTree: state.metertree.meterTree,
	forceBusy: state.metertree.forceBusy,
});

export default connect(mapStateToProps, bindAction)(MeterTree);



// WEBPACK FOOTER //
// ./src/components/LiveComponents/MeterTree/MeterTree.js